import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TerminalDataModel } from '@nutricontrol/app360-shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportsService } from '../../reports.service';
import { ReportsWaterSourceModel } from '../../reports-irrigation.costs';
import { TranslationsLibService } from '@nutricontrol/app360-shared';

@Component({
  selector: 'app-water-source-form',
  templateUrl: './water-source-form.component.html',
  styleUrls: ['./water-source-form.component.scss'],
})
export class WaterSourceFormComponent implements OnInit {
  @Input() terminal: TerminalDataModel;
  @Input() source: ReportsWaterSourceModel;
  @Output() formSubmitted = new EventEmitter<void>();
  @Output() formCancelled = new EventEmitter<void>();
  form: FormGroup;
  isEditing: boolean;

  constructor(
    public translationLib: TranslationsLibService,
    private fb: FormBuilder,
    private reportsService: ReportsService
  ) {}

  ngOnInit(): void {
    this.isEditing = !!this.source;

    this.form = this.fb.group({
      name: [null, Validators.required],
      type: [null, Validators.required],
    });

    if (this.isEditing) {
      this.form.patchValue({
        name: this.source.name,
        type: this.source.type,
      });
    }
  }

  onSubmit() {
    if (this.form.valid) {
      const data = {
        terminal_vid: this.terminal.vid,
        name: this.form.get('name').value,
        type: this.form.get('type').value,
      };

      if (this.isEditing) {
        this.reportsService.updateWaterSource(this.source.vid, data).subscribe({
          next: () => {
            this.formSubmitted.emit();
            console.log('Fuente de agua actualizada con éxito.');
          },
          error: (error) => {
            console.error('Error al actualizar la fuente de agua:', error);
          },
        });
      } else {
        this.reportsService.createWaterSource(data).subscribe({
          next: () => {
            this.formSubmitted.emit();
            console.log('Fuente de agua creada con éxito.');
          },
          error: (error) => {
            console.error('Error al crear la fuente de agua:', error);
          },
        });
      }
    }
  }

  cancel() {
    this.formCancelled.emit();
  }
}
